import { Box } from "@mui/material";
import { AppCircularProgress } from "./Components/Progress/AppCircularProgress";
import { useExternalSSO } from "./Hooks/ExternalSSO";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { setIsRedirectingToSso } from "JS/Helpers/LocalStorageHelpers";
import { isSafeSsoRedirect } from "JS/Helpers/SsoHelpers";

export const ExternalSSO = () => {
    const { resourceKey } = useParams() as any;
    const navigate = useNavigate();
    const onError = () => navigate(-1);
    const containerRef = useRef<HTMLDivElement>(null);
    const { loading, response } = useExternalSSO(resourceKey, onError);

    const [isReadyToSubmit, setIsReadyToSubmit] = useState(false);

    useEffect(() => {
        if (response) {
            setIsReadyToSubmit(true);
            if (containerRef?.current) {
                setIsRedirectingToSso("true");
                containerRef.current.innerHTML = response;
            }
        }
    }, [response]);

    useEffect(() => {
        if (isReadyToSubmit && containerRef.current) {
            const form = containerRef.current.getElementsByTagName("form")[0];

            if (form && isSafeSsoRedirect(form.getAttribute("action"))) {
                form.submit();
            } else {
                onError();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isReadyToSubmit]);

    return (
        <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            height="100dvh"
        >
            {loading && <AppCircularProgress />}
            <div ref={containerRef} />
        </Box>
    );
};
